import { FC } from 'react';
import { language } from '../../locale/config';

import { buildShareUrl, ServiceEnum } from '../../../utils';
import { IconTelegram } from '../../icons/telegram';
import { IconFacebook } from '../../icons/facebook';
import { IconTwitter } from '../../icons/twitter';
import { IconWhatsapp } from '../../icons/whatsapp';
import { IconTikTok } from '../../icons/tiktok';
import { IconShare } from '../../icons/share';
import { IconClose } from '../../icons/close';
import {
  CloseButton,
  ShareButton,
  ShareContainer,
  ShareMenu,
  ShareMenuWrapper,
} from './styled';
import { texts } from '../../../components/locale';

const shareOptions = [
  { component: IconFacebook, service: 'facebook' },
  { component: IconTwitter, service: 'twitter' },
  { component: IconTelegram, service: 'telegram' },
  { component: IconWhatsapp, service: 'whatsapp' },
];

type Props = {
  isOpen: boolean;
  onToggle: () => void;
};

export const Share: FC<Props> = ({ onToggle, isOpen }) => {
  return (
    <ShareContainer $isOpen={isOpen}>
      <ShareButton onClick={onToggle}>
        <span>{texts.share}</span>
        <span>
          <IconShare />
        </span>
      </ShareButton>

      <ShareMenuWrapper>
        <ShareMenu>
          {shareOptions.map((item) => (
            <li key={item.service}>
              <a
                target="_blank"
                href={buildShareUrl(item.service as ServiceEnum)}
              >
                <item.component />
              </a>
            </li>
          ))}
          <CloseButton>
            <button onClick={onToggle}>
              <IconClose></IconClose>
            </button>
          </CloseButton>
        </ShareMenu>
      </ShareMenuWrapper>
    </ShareContainer>
  );
};
